import { widgetWrappersCollection } from '../tools/widgetWrapper/widgetWrappersCollection'
import { WidgetWrapperEntity } from '../tools/widgetWrapper/widgetsWrapperEntity.js'

export default {
  created() {
    widgetWrappersCollection[this.model.$ID] = new WidgetWrapperEntity({
      model: this.model,
      getValue: () => this.getDataSourceField(this.model.Value),
      setValue: val => this.setDataSourceField(this.model.Value, val)
    })
  }
}
